import React, { useEffect } from "react";
import PropTypes from "prop-types";

import SuggestionItem from "./suggestion-item";

/**
 * @typedef {Object} SuggestionData
 * @property {string} id - The unique identifier for the suggestion.
 * @property {string} text - The text to be displayed for the suggestion you don't need to remove " | WaFd Bank" string here.
 * @property {Object} data - Additional data associated with the suggestion, can be used for custom behavior.
 */

/**
 * SuggestionsList component.
 *
 * @param {Object} props - The component props
 * @param {string} props.query - The current search query.
 * @param {SuggestionData[]} props.data - The query suggestions array.
 * @param {boolean} props.searchFormFocused - Flag to determine if the search bar whole form is focused.
 * @param {function} props.onSuggestionPopulate - Function to handle populate query button click, takes the data (SuggestionData) as argument.
 * @param {function} props.onSuggestionClick - Function to handle the click to the suggestion button, takes the data (SuggestionData) as argument.
 *
 * @returns {JSX.Element} The rendered SuggestionsList component
 */
const SuggestionsList = ({
  query = "",
  data = [],
  searchFormFocused = false,
  onSuggestionPopulate = (suggestionData) => {},
  onSuggestionClick = (suggestionData) => {}
}) => {
  const shouldDisplayResults = searchFormFocused && query !== "";
  const hasResults = data.length > 0;

  return (
    <div className="ss-list-container">
      {shouldDisplayResults &&
        hasResults &&
        data.map((suggestion, index) => (
          <React.Fragment key={suggestion.id}>
            <SuggestionItem
              data={suggestion}
              query={query}
              onPopulate={onSuggestionPopulate}
              onClick={onSuggestionClick}
              // isLast={index === data.length - 1} // Uncomment if you need to handle the last item differently
            />
          </React.Fragment>
        ))}
      {shouldDisplayResults && !hasResults && (
        <div className="my-2 mx-3">
          <p className="h6 mb-0">No results found</p>
        </div>
      )}
    </div>
  );
};

export default SuggestionsList;

SuggestionsList.propTypes = {
  query: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      data: PropTypes.object
    })
  ).isRequired,
  searchFormFocused: PropTypes.bool.isRequired,
  onSuggestionPopulate: PropTypes.func.isRequired,
  onSuggestionClick: PropTypes.func.isRequired
};
